import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import PrivateRoute from './components/PrivateRoute';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Focus from './pages/Focus';
import Tasks from './pages/Tasks';
import Groups from './pages/Groups';
import Statistics from './pages/Statistics';
import Settings from './pages/Settings';

// Styles
import './styles/App.css';

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        
                        <Route
                            path="/"
                            element={
                                <PrivateRoute>
                                    <Focus />
                                </PrivateRoute>
                            }
                        />
                        
                        <Route
                            path="/tasks"
                            element={
                                <PrivateRoute>
                                    <Tasks />
                                </PrivateRoute>
                            }
                        />
                        
                        <Route
                            path="/groups"
                            element={
                                <PrivateRoute>
                                    <Groups />
                                </PrivateRoute>
                            }
                        />
                        
                        <Route
                            path="/statistics"
                            element={
                                <PrivateRoute>
                                    <Statistics />
                                </PrivateRoute>
                            }
                        />
                        
                        <Route
                            path="/settings"
                            element={
                                <PrivateRoute>
                                    <Settings />
                                </PrivateRoute>
                            }
                        />
                        
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </Router>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
